module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_nagasaki-664e57711b3531af56f80855c6a3c12a.png";